/**
 * Color palette configuration for dark and light themes
 * Based on Material Design 3 and design requirements
 */

// Palette options moved to localized usage or any cast


// Dark theme colors (based on design reference)
export const darkPalette = {
  mode: 'dark' as const,
  primary: {
    main: '#4A90E2',
    dark: '#3A7BC8',
    light: '#5AA0F0',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#00B0FF',
    dark: '#0091EA',
    light: '#40C4FF',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#121212',
    paper: '#1E1E1E',
  },
  text: {
    primary: '#E3E3E3',
    secondary: '#A0A0A0',
    disabled: '#666666',
  },
  error: {
    main: '#F44336',
    light: '#E57373',
    dark: '#D32F2F',
  },
  warning: {
    main: '#FF9800',
    light: '#FFB74D',
    dark: '#F57C00',
  },
  info: {
    main: '#2196F3',
    light: '#64B5F6',
    dark: '#1976D2',
  },
  success: {
    main: '#4CAF50',
    light: '#81C784',
    dark: '#388E3C',
  },
  divider: '#2A2A2A',
  // Custom colors for admin portal
  customColors: {
    // Sidebar colors
    sidebarBackground: '#1A1A1A',
    sidebarActive: '#2A3A4A',
    sidebarText: '#E3E3E3',
    sidebarTextSecondary: '#A0A0A0',

    // Header colors
    headerBackground: '#1E1E1E',
    headerText: '#E3E3E3',

    // Card colors
    cardBackground: '#1E1E1E',
    cardBorder: '#333333',

    // Status colors
    statusHigh: '#F44336',
    statusMedium: '#FF9800',
    statusLow: '#4CAF50',

    // Table colors
    tableHeaderBackground: '#2A2A2A',
    tableRowHover: '#2A2A2A',
    tableBorder: '#333333',

    // Search bar
    searchBackground: 'rgba(255, 255, 255, 0.1)',
    searchBorder: '#333333',

    // Notification
    notificationBackground: '#1A2633',
    notificationBorder: '#2A3441',
  },
};

// Light theme colors
export const lightPalette = {
  mode: 'light' as const,
  primary: {
    main: '#1976D2',
    dark: '#1565C0',
    light: '#42A5F5',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#0288D1',
    dark: '#01579B',
    light: '#40C4FF',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F5F5F5',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#212121',
    secondary: '#757575',
    disabled: '#BDBDBD',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
    dark: '#C62828',
  },
  warning: {
    main: '#F57C00',
    light: '#FF9800',
    dark: '#E65100',
  },
  info: {
    main: '#1976D2',
    light: '#42A5F5',
    dark: '#1565C0',
  },
  success: {
    main: '#388E3C',
    light: '#66BB6A',
    dark: '#2E7D32',
  },
  divider: '#E0E0E0',
  // Custom colors for admin portal (light theme)
  customColors: {
    // Sidebar colors
    sidebarBackground: '#FFFFFF',
    sidebarActive: '#E3F2FD',
    sidebarText: '#212121',
    sidebarTextSecondary: '#757575',

    // Header colors
    headerBackground: '#FFFFFF',
    headerText: '#212121',

    // Card colors
    cardBackground: '#FFFFFF',
    cardBorder: '#E0E0E0',

    // Status colors
    statusHigh: '#D32F2F',
    statusMedium: '#F57C00',
    statusLow: '#388E3C',

    // Table colors
    tableHeaderBackground: '#F5F5F5',
    tableRowHover: '#F5F5F5',
    tableBorder: '#E0E0E0',

    // Search bar
    searchBackground: 'rgba(0, 0, 0, 0.05)',
    searchBorder: '#E0E0E0',

    // Notification
    notificationBackground: '#FFFFFF',
    notificationBorder: '#E0E0E0',
  },
};

